import create from "zustand";
import {devtools} from "zustand/middleware";

let filterStore = (set) => ({
  process: [],
  expiry: 0,
  assignee: [],
  page: 1,
  sortColumn: "priority",
  sortDirection: "ascending",
  isExpandAll: false,
  setProcess: (values) => {
    set((state) => ({process: values}));
  },
  setExpiry: (values) => {
    set((state) => ({expiry: values}));
  },
  setAssignee: (values) => {
    set((state) => ({assignee: values}));
  },
  setPage: (page) => {
    set((state) => ({page}));
  },
  setSortColumn: (sortColumn) => {
    set((state) => ({sortColumn}));
  },
  setSortDirection: (sortDirection) => {
    set((state) => ({sortDirection}));
  },
  setIsExpandAll: (isExpandAll) => {
    set((state) => ({isExpandAll}));
  }
});

filterStore = devtools(filterStore);

const useFilterStore = create(filterStore);

export default useFilterStore;



// WEBPACK FOOTER //
// ./src/stores/FilterStore.js